import { handleActions } from 'redux-actions'
import { displayToast, resetToast } from 'actions/toast'

const defaultState = {
  isShowing: false,
  type: null
}

const reducer = handleActions(
  {
    [displayToast]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => status,
    [resetToast]: () => defaultState
  },
  defaultState
)

export default reducer
